import type { CatalogItem } from '@viva/core';
import type { PlaybackError } from '@viva/player';
import { displayName } from '../../state/playback-context';
import { t } from '../../i18n';

interface CardActions {
  onNext?: () => void;
  onBack: () => void;
}

export function ErrorCard({ item, error, live, onRetry, onNext, onBack }: CardActions & { item: CatalogItem; error: PlaybackError; live: boolean; onRetry: () => void }) {
  return (
    <div className="player__error" role="alert">
      <h2>{displayName(item)}</h2>
      <p>{t(`playback.${error.code}`)}</p>
      <div>
        <button type="button" className="button primary" onClick={onRetry} autoFocus>
          {t('common.tryAgain')}
        </button>
        {onNext ? (
          <button type="button" className="button" onClick={onNext}>
            {live ? t('player.nextChannel') : t('player.nextEpisode')}
          </button>
        ) : null}
        <button type="button" className="button ghost" onClick={onBack}>
          {t('common.back')}
        </button>
      </div>
    </div>
  );
}

export function EndCard({ item, nextItem, onNext, onReplay, onBack }: CardActions & { item: CatalogItem; nextItem?: CatalogItem; onReplay: () => void }) {
  return (
    <div className="player__error" role="dialog" aria-label={t('player.finished')}>
      <h2>{displayName(item)}</h2>
      {nextItem ? <p>{t('player.upNext', { name: displayName(nextItem) })}</p> : <p>{t('player.finished')}</p>}
      <div>
        {nextItem && onNext ? (
          <button type="button" className="button primary" onClick={onNext} autoFocus>
            {t('player.playNext')}
          </button>
        ) : null}
        <button type="button" className={nextItem ? 'button' : 'button primary'} onClick={onReplay}>
          {t('player.watchAgain')}
        </button>
        <button type="button" className="button ghost" onClick={onBack}>
          {t('common.back')}
        </button>
      </div>
    </div>
  );
}
